import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, offerHighlights, PRICE, PRICE_ALT, PRODUCT } from '../data/content';
export function PricingSection() {
  return <section id="oferta" aria-labelledby="precio" className="bg-ink" data-id="element-136" data-mp="1j974ssyc6pzg">
      <div className="mx-auto max-w-page px-3 py-6 text-center sm:px-6 sm:py-8" data-id="element-137" data-mp="1nakb145ccv6w">
        <Reveal data-id="element-138" data-mp="1ncmzvkurcia1">
          <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.26em] text-gold sm:text-[0.78rem]" data-id="element-139" data-mp="1s9n5xvrlxl15">
            Oferta especial de lanzamiento
          </p>
          <h2 id="precio" className="mt-0.5 font-display text-xl font-black uppercase leading-tight text-white sm:text-3xl" data-id="element-140" data-mp="1x9hv9uvqi2k3">
            {PRODUCT}
          </h2>
          <p className="mx-auto mt-0.5 max-w-2xl text-[0.72rem] font-extrabold uppercase leading-snug tracking-[0.1em] text-blush sm:text-[0.8rem]" data-id="element-141" data-mp="2wjo3k5bzm0z">
            De principiante a comprender las bases del coreano
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mx-auto mt-3 max-w-2xl rounded-2xl border-2 border-gold bg-cream p-3.5 sm:p-5" data-id="element-142" data-mp="1hq7y1hynh7tr">
          <p className="font-display text-lg font-black uppercase text-ink sm:text-2xl" data-id="element-143" data-mp="1creou1qec2ze">
            6 Tomos + 5 Bonos
          </p>

          <ul className="mt-2.5 grid gap-1 text-left sm:grid-cols-2" data-id="element-144" data-mp="25fis6glhw3yx">
            {offerHighlights.map(item => <li key={item} className="flex items-center gap-2 rounded-lg bg-blush-soft px-2.5 py-1.5 text-[0.74rem] font-bold uppercase text-ink sm:text-[0.78rem]" data-id="element-145" data-mp="20fxvkctss7pd">
                <CheckIcon size={13} className="flex-shrink-0 text-coral" strokeWidth={3} data-id="element-146" data-mp="1rgj7tl50mb8k" />
                {item}
              </li>)}
          </ul>

          <p className="mt-3 rounded-lg bg-gold/20 px-3 py-1.5 text-[0.74rem] font-extrabold uppercase leading-snug text-ink sm:text-[0.8rem]" data-id="element-147" data-mp="fzazwpv5uczn">
            🎁 Más de {BONUS_VALUE} en bonos incluidos gratis
          </p>

          <p className="mt-2.5 text-[0.72rem] font-extrabold uppercase tracking-[0.18em] text-coral sm:text-[0.8rem]" data-id="element-148" data-mp="mei7dge8dl6g">
            🔥 Precio especial de lanzamiento
          </p>
          <p className="text-[0.66rem] font-bold uppercase tracking-[0.24em] text-slate sm:text-[0.72rem]" data-id="element-149" data-mp="cgu2hxmwuxak">
            Hoy todo por solo:
          </p>
          <p className="font-display text-4xl font-black leading-none text-coral sm:text-6xl" data-id="element-150" data-mp="3iiapsab5tgj">
            {PRICE}
          </p>
          <p className="mt-0.5 font-display text-base font-black uppercase text-ink sm:text-lg" data-id="element-151" data-mp="3kztatzh99or1">
            Pago único
          </p>
          <p className="text-[0.66rem] font-semibold uppercase tracking-wide text-slate sm:text-[0.72rem]" data-id="element-152" data-mp="3pv8iuasl0qfj">
            Sin mensualidades • Acceso Digital
          </p>

          <div className="mt-3 flex flex-col items-center gap-1.5" data-id="element-153" data-mp="3fyvsnmw8wupj">
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-154" data-mp="2xabivr234tt8">
              🔥 OBTÉN EL SISTEMA COMPLETO HOY
            </CtaButton>
            <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-155" data-mp="2sdl5xclkuec1">
              ¡SÍ! QUIERO APRENDER COREANO DESDE CERO POR {PRICE_ALT}
            </CtaButton>
            <p className="flex items-center gap-1.5 text-[0.66rem] font-bold uppercase tracking-wide text-slate sm:text-[0.72rem]" data-id="element-156" data-mp="31c6t5l1zuhj5">
              <ShieldCheckIcon size={13} className="text-gold" data-id="element-157" data-mp="3g8ec6i1o1cwu" />
              🛡️ Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}